import { render, staticRenderFns } from "./siteaside.vue?vue&type=template&id=ace2ea3c&scoped=true"
import script from "./siteaside.vue?vue&type=script&lang=js"
export * from "./siteaside.vue?vue&type=script&lang=js"
import style0 from "./siteaside.vue?vue&type=style&index=0&id=ace2ea3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace2ea3c",
  null
  
)

export default component.exports